import BackButton from 'components/BackButton';

import i18n from 'i18n-react';

interface DirectoryHeaderProps {
  source: boolean;
  logoWhite: string | null;
}

function DirectoryHeader({ source, logoWhite }: DirectoryHeaderProps) {
  const logoSrc = logoWhite ?? `https://s3.amazonaws.com/developertool/${import.meta.env.VITE_APP_ID}/logo_white.png`;

  return (
    <div className="header">
      {!source && <BackButton useHistory={false} text={i18n.translate('general.back')} />}
      <img src={logoSrc} className="logo" alt="logo" />
    </div>
  );
}

export default DirectoryHeader;
